export default __webpack_public_path__ + "media/images/services/service-02-370x250-fb15a38bacbdc6755b04bbdc1e0c610f.jpg";